import React from 'react'


const Cartproduct = ({product,handleRemove,handleIncrease,handleDecrease}) => {
   return (
    <div className="relative w-full max-w-3xl mx-auto bg-white border border-gray-200 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 p-5 mb-6">

      {/* Remove Button */}
      <button
        onClick={() => handleRemove(product.id)}
        className="absolute top-4 right-4 z-10 p-2 rounded-full bg-gray-100 text-gray-500 hover:bg-red-500 hover:text-white transition-all duration-200"
        aria-label="Remove Item"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div className="flex flex-col sm:flex-row gap-6 items-stretch">
        {/* Product Image */}
        <div className="w-full sm:w-1/2 rounded-xl overflow-hidden bg-gray-50 shadow-inner">
          <img
            src={product.image_url}
            alt={product.product_name}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Product Info */}
        <div className="w-full sm:w-1/2 flex flex-col justify-between ">
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 leading-tight mb-2 line-clamp-2">
              {product.product_name}
            </h2>
            <p className="text-2xl font-bold text-blue-600">
              ₹{product.amount}
            </p>

            {/* Product Options */}
            {product.options && Object.keys(product.options).length > 0 && (
              <div className="text-sm text-gray-600 mb-4 space-y-1">
                {Object.entries(product.options).map(([label, value]) => (
                  <div key={label}>
                    <span className="font-medium capitalize">{label}:</span> {value}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Quantity and Price */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-4">
            {/* Quantity Controls */}
            <div className="flex items-center space-x-4">
              <button
                onClick={() => handleDecrease(product.id)}
                className="w-10 h-10 rounded-full border border-gray-300 bg-black hover:bg-gray-800 text-2xl font-bold"
              >
                −
              </button>
              <span className="text-lg font-medium text-gray-800">{product.quantity}</span>
              <button
                onClick={() => handleIncrease(product.id)}
                className="w-10 h-10 rounded-full border border-gray-300 bg-black hover:bg-gray-800 text-xl font-bold"
              >
                +
              </button>
            </div>

            {/* Price */}

          </div>
        </div>
      </div>
    </div>
  );
}

export default Cartproduct
